"use client";
import * as React from "react";
import { Button } from "@base-ui-components/react/button";
import styles from "./index.module.css";
import { ReactNode } from "react";

type IconButtonProps = {
  title?: string;
  buttonContent: ReactNode;
  onClickFunc: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export default function IconButton({
  title,
  buttonContent,
  onClickFunc,
}: IconButtonProps) {
  return (
    <Button className={styles.Button} onClick={onClickFunc} title={title}>
      {buttonContent}
    </Button>
  );
}
